<template>
  <div class="box">
    <div class="box_header">
      <div class="rounded-container">
        <el-select
          v-model="formData.selectedOption"
          placeholder="请选择"
          class="select-with-search"
          @change="changeType"
        >
          <el-option
            v-for="item in selectTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select @change="changeCollege" v-model="formData.selectValue" class="rounded-input" v-if="formData.selectedOption === '1'">
          <el-option v-for="item in classRoomOption" :label="item.label" :value="item.value" :key="item.value"></el-option>
        </el-select>
        <el-input v-else="formData.selectedOption !== '1'" placeholder="请输入..." v-model="formData.searchValue" class="rounded-input" @input="searchViewList"></el-input>
      </div>
      <el-button type="text" class="reset" @click="reset">重置</el-button>
    </div>
    <div class="content">
      <van-list
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <component :is="componentType" :list="list" @handleCheckboxChange="handleCheckboxChange" @toggleExpand="toggleExpand"/>
      </van-list>
    </div>
    <div class="bottom_box" v-if="componentType === 'MyApplyRoomList'">
      <el-button class="yuyue__topost" round @click="goToPage">前往预约</el-button>
    </div>
    <van-action-sheet v-model="show" title="预约须知" v-if="componentType === 'ApplyRoomList'">
      <div style="padding: 16px 16px 16px;margin-bottom: 28px">
        <p style="color: #000;font-size: 18px;font-weight: 500;margin-bottom: 15px">使用规则和注意事项</p>
        <div v-html="labOpenRemark"></div>
        <!-- <p class="text"><span>预约时长</span>: 单次预约时长不得超过2节课，最多提前3天预约，系统无法预约当天实验室</p>
        <p class="text"><span>设备使用‌</span>: 实验设备使用过程中如有问题，需及时上报实验员‌。</p>
        <p class="text"><span>‌安全责任‌</span>: 申请人及导师对实验室的安全使用负全责‌。</p>
        <p class="text"><span>‌特殊情况‌</span>: 如有特殊情况需延长使用时间，需提前联系实验员重新预约‌。</p>
        <p class="text"><span>‌寒暑假及节假日‌</span>: 寒暑假及国家法定节假日期间申请使用实验室需经学院讨论同意‌。</p> -->
        <div style="display: flex;align-items: center;justify-content: space-between;margin-top: 20px">
          <div style="width: 165px;
                height: 50px;
                border: 1px solid #E5E5E5;
                border-radius: 25px;
                line-height: 45px;
                text-align: center;
                font-weight: 500;
                font-size: 18px;
                color: #666666;
                cursor: pointer" @click="show=false">不同意</div>
          <div style="width: 165px;
                height: 50px;
                border: 1px solid #E5E5E5;
                background: #13499B;
                border-radius: 25px;
                line-height: 45px;
                text-align: center;
                font-weight: 500;
                font-size: 18px;
                color: #fff;
                cursor: pointer" @click="goAgree()">同意</div>
        </div>
      </div>
    </van-action-sheet>
    <div class="bottom_box" v-if="componentType === 'ApplyRoomList'">
      <el-button class="yuyue__tomy" round @click="goToMyReservation">我的预约</el-button>
      <el-button class="yuyue__topost" round @click="goToReservation">立即预约</el-button>
    </div>
  </div>
</template>

<script>
import {Notify} from "vant";
import { Toast } from 'vant';
import ApplyRoomList from './components/ApplyRoomList.vue';
import MyApplyRoomList from './components/MyApplyRoomList.vue';

export default {
    components: {ApplyRoomList,MyApplyRoomList},
    data() {
      return {
        labOpenRemark: '',
        searchMap: {
          '1': 'xyName',
          '2': 'orgName',
          '3': 'labName',
          '4': 'labJj'
        },
        classRoomOption: [], //学院列表
        formData:{
          selectedOption: '3', // 默认选中的选项值
          searchValue: '',    // 搜索框的绑定值
          selectValue: '',// 选中的学院id
          selectName: '' // 选中的学院名称
        },
        show: false,
        orgName:'',
        labName:'',
        loading: false,
        finished: false,
        total:0,
        page: 1, // 当前页码
        pageSize: 12, // 每页加载的数据量
        options: [],
        list:[],
        selectedCard:{},
        firstLoadWithSearch: true,
        previousSearchValue:''
      };
    },
    methods: {
      reset(){
        this.changeType()
      },
      toggleExpand(id){
        this.list.forEach((item, index) => {
          if ((item.labId || item.id) === id) {
            this.list[index].expand = !this.list[index].expand
          }
        });
      },
      goToMyReservation(){
        this.$router.push('/myApply');
      },
      async goToReservation(){
        if(this.selectedCard.labId){
          this.show = true
          const res = await axios.post('/baseinfo/getLabInfosDetail2?id='+this.selectedCard.labId)
          this.labOpenRemark = res.data.labOpenRemark ?? '<p>暂无说明</p>'
        } else {
          Toast('请选择预约实验室');
        }
      },
      handleCheckboxChange(id){
        let selected = {};
        this.list.forEach((item, index) => {
          if (item.Id === id) {
            const newCheckState = !item.check;
            this.$set(this.list[index], 'check', newCheckState);
            if (newCheckState) {
              selected = item;
            }
          } else {
            this.$set(this.list[index], 'check', false);
          }
        });
        this.selectedCard = selected;
      },
        // 切换学院下拉菜单
        changeCollege(value){
            const collage = this.classRoomOption.filter(item=>{
                return item.value === value
            })
            if(collage) this.formData.selectName = collage[0].label
            this.list = [];
            this.page = 1; // 确保从第一页开始
            this.finished = false;
            this.getLabList()
        },
        goAgree(){
          this.$router.push({
            path:'/reservation',
            query:{labName:this.selectedCard.labName,labId:this.selectedCard.labId}
          })
        },
        goToPage(){
          this.$router.push('/applySelect')
        },
        changeType(){
            this.list = [];
            this.formData.searchValue = ''
            this.formData.selectValue = ''
            this.formData.selectName = ''
            this.page = 1; // 确保从第一页开始
            this.finished = false;
            this.getLabList()
            // 切换到学院名称
            if(this.formData.selectedOption === '1') this.getCollageList()
        },
        // canlApply(item){//2025/5/7去掉取消预约功能
        //   axios.get("/labOpen/cancelMYApply?id=" + item.id, {
        //       headers: {
        //         "Content-Type": "application/x-www-form-urlencoded"
        //       }
        //     })
        //     .then(function(response) {
        //       if (response.data.code == 2) {
        //         Notify({ type: 'success', message: '取消预约成功' });
        //        window.location.reload()
        //       } else {
        //         Notify({ type: 'danger', message: '取消预约失败' });

        //       }
        //     })
        // },
        async searchViewList(){
            try {
                this.page = 1; // 确保从第一页开始
                await this.getLabList();
            } catch (error) {
                this.finished = true
                this.loading = false;
            }
        },
        async onLoad() {
            if (this.finished || !this.list.length) return;
            // 更新页码
            this.page++;
            this.getLabList({page: this.page})
        },
        async getCollageList() {
            const listForm = this.translateForm({type: '2', status: 2})
            const { data, status } = await axios.post('/baseinfo/getOrgSelectFromUser', listForm, {
                headers: {
                'Content-Type': 'multipart/form-data'
                }
            });
            if(status === 200) {
                this.classRoomOption = data.map(roomData => {
                return {label: roomData.name, value: roomData.id}
                })
            }
        },

        async getLabList(args) {
            const formDataTranslate = this.translateForm({
                [this.searchMap[this.formData.selectedOption]]: this.formData.selectedOption=='1' ? this.formData.selectName : this.formData.searchValue,
                type: this.componentType === 'MyApplyRoomList' ? 'apply' : null,
                page: this.page,
                pageSize: this.pageSize,
            })

            try {
                const response = await axios.post(this.api, formDataTranslate, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });

                if (response.status === 200) {
                  const { data, total } = response.data;
                  const clData = data.map(item => {
                    return {
                      ...item, expand: false
                    }
                  })
                  if( args && args.page ) {
                      this.list = [...this.list, ...clData];
                  } else {
                      this.list = clData;
                  }
                  this.total = total;
                  this.loading = false;

                  // 如果当前加载的数据量等于总数据量，则设置 finished 为 true
                  if (this.list.length >= this.total) {
                      this.finished = true;
                  } else {
                      this.finished = false;
                  }
                }
            } catch (error) {
                this.finished = true;
                this.loading = false;
            } finally {
                this.loading = false;
            }
        },
    },
    watch: {
      $route(to, from) {
        this.formData.selectedOption = '3'
        this.changeType()
      },
        // 监听 list 中的 check 属性变化
        // list: {
        //   handler() {
        //     this.handleSelectionChange();
        //   },
        //   deep: true
        // }
    },
    computed: {
        api() {
            if(this.$route.path === '/applySelect') return '/labOpen/getMWPhoneOpenLabList'
            return '/labOpen/getOpenApplyList'
        },
        selectTypeOptions(){
          return [
              { value: '1', label: '学院名称' },
              { value: '2', label: '实验中心（室）名称' },
              { value: '3', label: '实验教室名称' },
          ]
        },
        componentType(){
            return this.$route.path === '/applySelect' ? 'ApplyRoomList' : 'MyApplyRoomList'
        },
        // 计算属性用于获取所有选中的卡片
        selectedCards() {
            return this.list.filter(c => c.check);
        }
    },
    mounted() {
      this.getLabList()
    }
};
</script>

<style scoped>
.box{
  width: 100%;
  background-color: #f3f3f3;
  height:calc(calc(100vh - 65px));
}
.reset {
  margin-left:5px;
}
.box .box_header {
  display: flex;
  padding:10px;
  width:100%;
}
.rounded-container {
  display: flex;
  flex:1;
  border-radius: 20px;
  overflow: hidden; /* 确保子元素不会溢出圆角 */
}
.rounded-input {
  flex: 1;
  background-color: #f2f2f4!important;
}
::v-deep .rounded-input .el-input-group {
  background-color: #f2f2f4!important;
  border-radius: 20px !important;
}

::v-deep .rounded-input .el-input-group__prepend,
::v-deep .rounded-input .el-input__inner {
  border: none !important;
}
::v-deep .select-with-search .el-input__inner {
  border: 0;
}
.select-with-search {
  width: 100px;
  border-top-left-radius: 20px !important;
  border-bottom-left-radius: 20px !important;
  background-color: #fff !important; /* 确保选择器背景与输入框一致 */
}
.content{
  width: 100%;
  height: calc(calc(100vh - 65px) - 75px);
  overflow-y: auto;
  padding: 0 15px;
}
::v-deep .el-card__body, .el-main{
  padding: 14px 20px;
}
::v-deep .el-card__header{
  padding: 0;
  position: relative;
}
.tag{
  position: absolute;
  right: 0;
  top: 0;
  width: 62px;
  height: 26px;
  background: #13499B;
  border-radius: 0 8px 0 8px;
  color: #FFFFFF;
  text-align: center;
  line-height: 26px;
}
.tag1{
  position: absolute;
  right: 0;
  top: 0;
  width: 62px;
  height: 26px;
  background: #E4E7EC;
  border-radius: 0 8px 0 8px;
  color: #666666;
  text-align: center;
  line-height: 26px;
}
.bottom_box{
  display: flex;
  width: 100%;
  z-index: 999;
  height: 80px;
  background-color: #fff;
  position: absolute;
  bottom: 0;
  padding: 18px 15px;
  line-height: 80px;
}
.bottom_box .yuyue__tomy{
  flex: 1;
  background-color: #329977;
  color: #FFFFFF;
  border: none;
}
.bottom_box .yuyue__topost {
  flex: 1;
  background-color: #13499b;
  color: #FFFFFF;
  border: none;
}
</style>
